import styled from "styled-components";

const Wrapper = styled.div`
  margin: 40px 0;
`;

export { Wrapper };
